import {createSlice} from '@reduxjs/toolkit'
import reject from 'lodash/reject'

export type SearchState = {
  searchText: string
  results: any[]
  selectedVariants: any[]
  existingItems: any[]
}

const initialState: SearchState = {
  searchText: '',
  results: [],
  selectedVariants: [],
  existingItems: [],
}

export const selectProduct = (product: any) => (dispatch: any, getState: any) => {
  const {
    orders: {draft},
  } = getState()
  const orderItems = draft.order.items
  const {name, imageSrc, variants} = product
  let _variants = reject(variants.nodes, (variant: any) => {
    return orderItems.some((item: any) => item.variantId === variant.id)
  })

  _variants = _variants.map((variant: any) => ({
    ...variant,
    product: {name, imageSrc},
  }))

  dispatch(addProduct(_variants))
}

const searchProductSlice = createSlice({
  name: 'searchProduct',
  initialState: initialState,
  reducers: {
    setSearchText: (state, action) => {
      state.searchText = action.payload
    },

    setSearchResults: (state, action) => {
      state.results = action.payload
    },

    addProduct: (state, action) => {
      state.selectedVariants = [...state.selectedVariants, ...action.payload]
    },

    removeProduct: (state, action) => {
      state.selectedVariants = reject(state.selectedVariants, {productId: action.payload})
    },

    addVariant: (state, action) => {
      state.selectedVariants.push(action.payload)
    },
    clearSearch: (state) => {
      state.searchText = ''
      state.selectedVariants = []
    },

    setExistingItems: (state, action) => {
      state.existingItems = action.payload
    },

    removeVariant: (state, action) => {
      state.selectedVariants = reject(state.selectedVariants, {id: action.payload})
    },

    resetSearchState: () => {
      return initialState
    },
  },
})

export const {
  setSearchText,
  setSearchResults,
  addProduct,
  removeProduct,
  addVariant,
  clearSearch,
  removeVariant,
  resetSearchState,
  setExistingItems,
} = searchProductSlice.actions

export default searchProductSlice.reducer
